/**
 * @author Sasanka Weerakoon
 * @version 0.0.1
 * @since 21/4/2025
 */

import React, { useRef, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Stack, FormControl } from "@mui/material";
import Select from "react-select";
import { Button } from "@mui/material";
import api from "../../../../base/services/AuthApi";
import Alerts from "../../../../base/errorHandeling/Alerts";
import { FetchErrorHandeling } from "../../../../base/errorHandeling/FetchErrorHandeling";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import UserReportTable from "./UserReportTable";


const UserReport = () => {

    const selectUserRef = useRef(null)

    const [data, setData] = useState([]);
    const [userType, setUserType] = useState("")

    const [loading, setLoading] = useState(false);

    const [isSuccess, setIsSuccess] = useState(false)
    const [successMessages, setSuccessMessages] = useState([])

    const [isError, setIsError] = useState(false)
    const [isErrorShow, setIsErrorShow] = useState(false)
    const [errorMessages, setErrorMessages] = useState([])

    const userTypeOptions = [
        { value: "VA", label: "All" },
        { value: "VAU", label: "Approved Users" },
        { value: "VAP", label: "Pending Users" },
    ];

    useEffect(() => {
        if (isError === true) {
            setTimeout(() => {
                setIsError(false)
                setErrorMessages([])
            }, 10000)
        }
    }, [isError])

    useEffect(() => {
        if (isSuccess === true) {
            setTimeout(() => {
                setIsSuccess(false)
                setSuccessMessages([])
            }, 3000)
        }
    }, [isSuccess])

    let userConfig = {
        headers: {
            Action: userType ?? "VA",
            "Sort-Column": "userId",
        },
    };


    const fetchUserReportData = () => {
        setLoading(true)
        api
            .get("/users/all", userConfig)
            .then((res) => {
                setData(res.data?.dataList)
                setLoading(false);
                setErrorMessages([]);
                setIsError(false);
            })
            .catch((err) => {
                setLoading(false);
                FetchErrorHandeling(
                    err,
                    setIsError,
                    setErrorMessages,
                    setIsErrorShow);
            });
    }

    const customStyles = {
        control: (provided) => ({
            ...provided,
            padding: "10px",
        }),
    }

    return (
        <Box
            sx={{ width: "100%" }}>
            <Stack className="report-filters" spacing={4} direction="row">
                <div>
                    <p
                        style={{
                            fontSize: "12px",
                            position: "relative",
                            top: "-9px",
                            left: "10px",
                            background: "#fff",
                            width: "200px",
                            paddingLeft: "5px",
                            zIndex: 99,
                        }}
                    >User scope
                    </p>
                    <FormControl
                        required={false}
                        sx={{
                            minWidth: 400,
                            zIndex: 90,
                            position: "relative",
                            top: "-32px",
                            height: 0,
                        }}
                        size="medium"
                    >
                        <Select
                            ref={selectUserRef}
                            options={userTypeOptions}
                            value={userTypeOptions.find((option) => option.value === userType)}
                            onChange={(selectedOption) =>
                                setUserType(selectedOption?.value ?? "")
                            }
                            isClearable
                            styles={{
                                ...customStyles,
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                }),
                            }}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </FormControl>
                </div>
            </Stack>

            <Stack className="report-actions" spacing={2} direction="row" sx={{ my: 3 }}>
                <Button
                    color="warning"
                    variant="contained"
                    onClick={fetchUserReportData}
                    disabled={!userType}
                    startIcon={<SearchIcon />}
                >
                    Search
                </Button>
                <Button
                    color="error"
                    variant="outlined"
                    onClick={() => {
                        setData([])
                        setUserType("")
                        setSuccessMessages([])
                        setErrorMessages([])
                        setIsError(false)
                        setIsSuccess(false)
                        selectUserRef.current.clearValue()
                    }}
                    startIcon={<CloseIcon />}
                >
                    Clear
                </Button>
            </Stack>

            {!isSuccess &&
                <Alerts
                    iserror={isError}
                    errorMessages={errorMessages}
                    isSuccess={isSuccess}
                    successMessages={successMessages}
                    iserrorShow={isErrorShow}
                />
            }

            <UserReportTable
                userReportData={data}
                loading={loading}
            />

        </Box>
    )
}

export default UserReport
